import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

export const LoginSelectionPage = () => {
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = useState('other');

  const loginTypes = [
    {
      id: 'other',
      label: 'Coach / Scout / Media',
      description: 'Sign in with email and password'
    },
    {
      id: 'player',
      label: 'Player',
      description: 'Sign in with team and player name'
    }
  ];

  const handleContinue = () => {
    if (selectedType === 'player') {
      navigate('/auth/login-player');
    } else {
      navigate('/auth/login');
    }
  };

  return (
    <main className="min-h-screen bg-jp-page text-jp-ink text-left overflow-x-hidden">
      {/* Navy strip behind the see-through navbar so its white logo and links stay readable */}
      <div className="bg-jp-band h-16 sm:h-20" aria-hidden="true" />

      <section className="px-4 sm:px-6 lg:px-8 pt-14 sm:pt-20 pb-16 sm:pb-20">
        <div className="max-w-2xl mx-auto text-center mb-8">
          <p className="text-jp-accent dark:text-jp-gold text-sm font-bold uppercase tracking-widest mb-3">
            Welcome Back
          </p>
          <h1 className="text-5xl sm:text-6xl font-anton leading-[1.1] tracking-tight text-jp-ink">
            LOGIN TO YOUR ACCOUNT
          </h1>
          <p className="mt-4 text-jp-muted text-sm sm:text-base">
            Pick how you'd like to sign in.
          </p>
        </div>

        <div className="max-w-3xl mx-auto bg-jp-card rounded-2xl border border-jp-outline/70 shadow-sm p-5 sm:p-8">
          {/* Login type tiles */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" role="radiogroup" aria-label="Account type">
            {loginTypes.map((type) => {
              const isSelected = selectedType === type.id;
              return (
                <button
                  key={type.id}
                  type="button"
                  role="radio"
                  aria-checked={isSelected}
                  onClick={() => setSelectedType(type.id)}
                  className={`relative rounded-xl px-6 pt-10 pb-8 min-h-[170px] sm:min-h-[200px] flex flex-col items-center justify-center text-center border transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-jp-accent ${
                    isSelected
                      ? 'bg-jp-accent/10 border-jp-accent ring-1 ring-jp-accent'
                      : 'bg-jp-section border-jp-outline/50 hover:border-jp-accent/60'
                  }`}
                >
                  {/* Selection dot */}
                  <span
                    className={`absolute top-4 right-4 w-6 h-6 rounded-full border-2 flex items-center justify-center transition-colors ${
                      isSelected ? 'border-jp-accent' : 'border-jp-line'
                    }`}
                  >
                    {isSelected && <span className="w-3 h-3 rounded-full bg-jp-accent" />}
                  </span>

                  <span className={`text-lg sm:text-2xl font-bold ${isSelected ? 'text-jp-accent' : 'text-jp-ink'}`}>
                    {type.label}
                  </span>
                  <span className="mt-2 text-sm text-jp-muted">
                    {type.description}
                  </span>
                </button>
              );
            })}
          </div>

          <div className="max-w-md mx-auto pt-8">
            <button
              type="button"
              onClick={handleContinue}
              className="w-full py-4 text-base font-bold uppercase tracking-wider bg-gradient-to-r from-cyan-400 via-cyan-500 to-blue-600 text-slate-900 rounded-xl hover:brightness-110 transition-all shadow-lg shadow-cyan-500/20 focus:outline-none focus-visible:ring-2 focus-visible:ring-jp-accent focus-visible:ring-offset-2 focus-visible:ring-offset-jp-card active:scale-[0.98]"
            >
              Continue
            </button>
          </div>

          <p className="px-2 pt-5 pb-1 text-center text-sm sm:text-base text-jp-muted">
            Don't have an account?{' '}
            <Link to="/auth/signup" className="font-semibold text-jp-accent hover:underline">
              Sign up
            </Link>
          </p>
        </div>
      </section>
    </main>
  );
};

export default LoginSelectionPage;
